import { useState, useEffect } from "react";
import classes from "./Variants.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Variants({ product, productSlug, translateKey, productVariant, setProductVariant, setQuantity }) {
    const { t } = useTranslation();

    const defaultSlugPath = product?.item?.slug_path;

    const navigate = useNavigate();
    let variant_options = product?.variant_options;
    let variant_items = product?.variant_items;
    const [selected, setSelected] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);

    /*
     *Iz selektovanih varianti stvara key. Proverava postoji li takav key u listi variant proizvoda
     * Ako postoji, izbacuje tu variantu tj taj proizvod
     **/
    const getCurrentProductFromPathname = (selectedItems) => {
        const currentItem = variant_items.find((item) => {
            const variant_key_array = item?.variant_key_array;

            if (variant_key_array?.length !== selectedItems?.length) {
                return false;
            }
            // Provera da li su svi elementi iz selectedItems prisutni u variant_key_array
            const allItemsMatch = selectedItems.every((selectedItem) =>
                variant_key_array.some((variant) => variant.attribute_key === selectedItem.attribute_key && variant.value_key === selectedItem.value_key)
            );

            return allItemsMatch;
        });

        return currentItem;
    };

    useEffect(() => {
        if (selectedColor !== null) {
            navigate(`?color=${selectedColor}`, { replace: false });
        }
    }, [selectedColor]);

    // Ucitavanje inicijalnih vrednosti
    useEffect(() => {
        if (product?.item?.slug === productSlug) return;

        let selected_item = variant_items.find((item) => item.slug_path.includes(productSlug));
        // let selected_item = variant_items.find((item) => item.slug_path === productSlug);
        if (selected.length == 0) {
            if (selected_item && product?.item?.slug !== productSlug) {
                setSelected(selected_item.variant_key_array);
            }
            if (selected_item) {
                const currentItem = getCurrentProductFromPathname(selected_item?.variant_key_array);
                setProductVariant(currentItem);
            }
        }
    }, []);

    // onChangeHandler funkcija za selektovanje variant nakon odabira vrednosti
    const onChangeHandler = (attribute_key, value_key) => {
        let temp_selected = [...selected];

        let temp_selected_item = {
            attribute_key: attribute_key,
            value_key: value_key,
        };

        let temp_index = temp_selected.findIndex((x) => x.attribute_key == temp_selected_item.attribute_key);

        if (temp_index > -1) {
            temp_selected[temp_index] = temp_selected_item;
        } else {
            temp_selected.push(temp_selected_item);
        }

        setSelected(temp_selected);
        if (setQuantity) setQuantity();

        const currentItem = getCurrentProductFromPathname(temp_selected);
        setProductVariant(currentItem ?? []);

        window?.history?.replaceState(null, null, `${currentItem ? currentItem.slug_path : defaultSlugPath}`);
    };

    return (
        <div className={`flex flex-col  gap-3 max-lg:w-full ${classes.flex} 2xl:w-1/2`}>
            {variant_options?.map((item, i) => {
                return (
                    <div className={`${classes.flex1} flex flex-col gap-0.5`} key={i}>
                        <label className={classes.flexLabel} htmlFor={item?.id}>
                            {item?.attribute?.name}
                        </label>
                        <select
                            key={item?.id}
                            id={item?.id}
                            name={item?.attribute?.key}
                            className={classes.variants}
                            onChange={(e) => {
                                e.preventDefault();
                                onChangeHandler(item.attribute.key, e.target.value);
                            }}
                        >
                            <option value={`none`}>{t(`${translateKey}-choose`)}</option>
                            {item?.values?.map((value, i) => {
                                // let display = value?.display;

                                const isSelected = selected.some((x) => x.attribute_key === item.attribute.key && x.value_key === value.key);

                                let display = "show";
                                return (
                                    <option key={i} value={value?.key} selected={isSelected} style={{ display: value.display }} className={display === "show" ? classes.show : classes.hide}>
                                        {value?.name}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                );
            })}
        </div>
    );
}
